import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  margin: 4px 0 16px;
`;

export const ProgressList = styled.li<{
  percentage: number;
}>`
  ${({ theme, percentage }) => css`
    display: block;
    position: relative;
    width: 100%;
    height: 2px;
    overflow: hidden;
    border-radius: 2px;
    background: ${theme.backgroundColor.onelevated};

    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: ${percentage}%;
      height: 2px;
      transition: width 0.3s ease-in-out;
      background: ${theme.themeColor.main_1};
    }
  `}
`;
